export const RESEND_TIMEOUT_SECONDS = 60;
